import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardMetricCardComponent } from '../../../../../../shared/components/dashboard-metric-card/dashboard-metric-card.component';

@Component({
  selector: 'app-monitoring',
  standalone: true,
  imports: [CommonModule, DashboardMetricCardComponent],
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.css'],
})
export class MonitoringComponent {
  @Input() connectionIssuesCount: number = 0;
  @Input() missingDataCount: number = 0;
  @Input() nonConformitiesCount: number = 0;
  @Input() isLoadingConnectionIssues: boolean = true;
  @Input() isLoadingMissingData: boolean = true;
  @Input() isLoadingNonConformities: boolean = true;
}
